import type { Fleet } from '../../../../../types'

export function fleetReportColumns() {
  const exportColumns: { key: keyof Fleet; header: string; width: number }[] = [
    { key: 'accountID', header: 'Kontonr', width: 15 },
    { key: 'regNo', header: 'Regnr', width: 15 },
    { key: 'vehicleID', header: 'Kjøretøy Id', width: 15 },
    { key: 'driverName', header: 'Fører', width: 25 },
    { key: 'HK', header: 'Status', width: 10 },
    { key: 'totalTerms', header: 'Leieperiode', width: 10 },
    { key: 'totalKm', header: 'KM PT', width: 15 },
    { key: 'budgetKm', header: 'KM simulert', width: 15 },
    { key: 'maxKm', header: 'Maks km', width: 15 },
    { key: 'fixedYear', header: 'Faste kostnader hittil', width: 20 },
    { key: 'fixedContract', header: 'Faste kostnader', width: 20 },
    { key: 'nonFixedYear', header: 'Variable kostnader hittil', width: 20 },
    { key: 'nonFixedContract', header: 'Variable kostnader', width: 20 },
    { key: 'totalYear', header: 'Totale kostnader hittil', width: 20 },
    { key: 'totalContract', header: 'Totale kostnader', width: 20 },
  ]

  return exportColumns
}
